import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RandomProducts from './snippet/RandomProducts';

function ColumnComponent({ column, grid, sm, md, lg, length, columnclass, rowIndex, columnIndex ,clientName,language }) {
  const [expanded, setExpanded] = useState(column.toggleExpand === 'yes');
  const [fetchedHTML, setFetchedHTML] = useState(null);
  const widgetId = `client-widget-en-${rowIndex}-${columnIndex}`;

  useEffect(() => {
    setFetchedHTML(null);
    if (column.contentHTML && column.contentHTML.endsWith('.html')) {
      fetch(column.contentHTML)
        .then(response => response.text())
        .then(data => {
          data = data.replace(/\[random-(\d+)\]/g, (_, range) => {
            return Math.floor(Math.random() * parseInt(range, 10)) + 1;
          });
          setFetchedHTML(data);
        })
        .catch(error => console.error('Error loading HTML file:', error));
    }
  }, [column.contentHTML]);

  if (column.displayStatus === 'inactive') {
    return null;
  }

  const widgetStyle = {};
  let addClassFixedwidth = '';
  if (column.width && !grid) {
    widgetStyle.width = `${column.width}px`;
    addClassFixedwidth = 'set-custom-width';
  }

  if (column.height) {
    widgetStyle.height = `${column.height}px`;
  }

  if (!length) {
    widgetStyle.margin = '0 auto';
  }

  const displayDevice = column.displayDevice;
  let widgetClassName = '';
  if (!displayDevice.includes('mobile')) widgetClassName += ' mob-hide';
  if (!displayDevice.includes('tablet')) widgetClassName += ' tab-hide';
  if (!displayDevice.includes('desktop')) widgetClassName += ' des-hide';

  const InnerContent = (
    <>
      {column.iframeHTML && <div className="h-100 text-center widget-content" dangerouslySetInnerHTML={{ __html: column.iframeHTML }} />}
      {column.customFeature === "RandomProducts" && <div className="widget-content p-2 p-lg-3 h-100">
        <RandomProducts clientName={clientName} language={language}/>    
        </div>}
      {fetchedHTML ? (
        <div className="widget-content p-2 p-lg-3 flex-grow-1">
          <div className="h-100" dangerouslySetInnerHTML={{ __html: fetchedHTML }} />
        </div>
      ) : (
        column.contentHTML && !column.contentHTML.endsWith('.html') && (
          <div className="p-2 p-lg-3">
            <div dangerouslySetInnerHTML={{ __html: column.contentHTML }} />
          </div>
        )
      )}
      {column.contentCSS && <style className="text-center" dangerouslySetInnerHTML={{ __html: column.contentCSS }} />}
    </>
  );

  const handleChange = () => {
    setExpanded(!expanded);
  };

  const AccordionComponent = (
    <>
      {column.toggleStatus === 'active' ? (
        <Accordion expanded={expanded} onChange={handleChange} classes={{ content: 'p-0 m-0' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} classes={{ content: 'p-0 m-0' }}>
            <h5 className="mb-0 widget-title">{column.title}</h5>
          </AccordionSummary>
          <AccordionDetails>{InnerContent}</AccordionDetails>
        </Accordion>
      ) : (
        <div
          className={`widget make-column-height-same d-flex flex-column ${!column.displayType.includes('pdf') ? 'hide-in-pdf' : ''} ${widgetClassName} ${addClassFixedwidth}`}
          style={widgetStyle}
          id={widgetId}
        >
          {column.title && (
            <div className="widget-title-border">
              <h5 className="text-center text-md-start widget-title" style={{ margin: '0 1em' }}>
                {column.title}
              </h5>
            </div>
          )}
          {InnerContent}
        </div>
      )}
    </>
  );

  return grid === 'Show' ? (
    <Grid item xs={12} sm={sm} md={md} lg={lg} className={widgetClassName}>
      {columnclass}
      {AccordionComponent}
    </Grid>
  ) : (
    <div className={`widget-row avoid-print-break-inside ${!column.displayType.includes('pdf') ? 'hide-in-pdf' : ''}`}>{AccordionComponent}</div>
  );
}

function Widgets({ activeTheme, clientName, font, language, setActiveTheme, selectedLayout, carbon, rating, addcss }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  activeTheme = activeTheme || params.get('color') || "yellow";
  language = language || params.get('language') || "english";
  clientName = clientName || params.get('clientName') || "apparel";
  selectedLayout = selectedLayout || params.get('layout') || "layout-featured";
  font = font || params.get('font') || "fira";
  carbon = carbon || params.get('carbon') || "0";
  rating = rating || params.get('rating') || "0";
  addcss = addcss || params.get('addcss') || "0";

  const [data, setData] = useState(null);


useEffect(() => {
  const fetchData = async () => {
    try {
      let response;
      if (clientName) {              
        response = await fetch(`/invoice/client/${clientName}/content/${language}/widget.json`);            
      } else {              
        response = await fetch(`/json/widget-${language}.json`);              
      }
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error('Error fetching json data:', error);
    }
  };
  fetchData();
}, [language, clientName]);

  if (!data) {
    return null;
  }

  return (
    <>
      {data.widgetAreaCSS && <style dangerouslySetInnerHTML={{ __html: data.widgetAreaCSS }} />}
{data && data.widgetAreaCSS && (
      <style dangerouslySetInnerHTML={{ __html: data.widgetAreaCSS }} ></style>
    )}
<div 
  key={language} 
  className={`widget-root Xtheme-${activeTheme} ${selectedLayout}`} 
  dir={language === 'arabic' ? 'rtl' : ''}
>
<div className='invoice-wrap mt-3'>
      {data &&
        data.rows.map((row, rowIndex) => (
          row.columns.filter((column) => column.displayStatus === 'active').length === 2 ? (
              // If it's the first row and there are exactly two columns with "displayStatus": "active," use a grid
              <div className={`widget-row avoid-print-break-inside`}>
              <Grid container spacing={2} className={'invo-2-col'}>
                {row.columns
                  .filter((column) => column.displayStatus === 'active')
                  .map((column, columnIndex) => (
                    <ColumnComponent key={`${language}-${rowIndex}-${columnIndex}`} column={column} grid={'Show'} sm={12} md={6} lg={6} length={row.columns.length} rowIndex={rowIndex} columnIndex={columnIndex} clientName={clientName} language={language}/>
                  ))}
                </Grid>
                <style>{`@media (min-width: 576px) {.MuiGrid-root.MuiGrid-grid-lg-6 {flex-basis: 50% !important;max-width: 50% !important;}}`}</style>
                </div>
                
            ) : row.columns.filter((column) => column.displayStatus === 'active').length === 3 ? (
              // If it's the first row and there are exactly two columns with "displayStatus": "active," use a grid
              <div className={`widget-row avoid-print-break-inside ${row.columns.some(col => !col.displayType.includes('pdf')) ? 'hide-in-pdf' : ''}`}>
                <Grid container spacing={2} className={'invo-3-col'}>
                {row.columns
                  .filter((column) => column.displayStatus === 'active')
                  .map((column, columnIndex) => (
                    <ColumnComponent key={`${language}-${rowIndex}-${columnIndex}`} column={column} grid={'Show'} md={4} lg={4} length={row.columns.length} rowIndex={rowIndex} columnIndex={columnIndex} clientName={clientName} language={language}/>
                  ))}
                </Grid></div>
            ) : (
              // For other rows or when there are multiple columns with "displayStatus": "active," use ColumnComponent directly
              row.columns
                .filter((column) => column.displayStatus === 'active')
                .map((column, columnIndex) => (
                  <>
                  <ColumnComponent key={`${language}-${rowIndex}-${columnIndex}`} column={column} rowIndex={rowIndex} columnIndex={columnIndex} clientName={clientName}  language={language}/> 
                  </>
                )))          
        ))}
       {/*  <DeviceButtons onButtonClick={handleButtonClick} /> */}
    </div>     
    </div> 
    <style>{`
        ${carbon === "0" ? `.carbon { display: none !important; }` : ""}
        ${rating === "0" ? `.rating-btn { display: none !important; }` : ""}
        ${(selectedLayout === "layout-a4print") ? ` 
          div.mobile-menu { display: none; }
          .rating-row, .collapsed-accordion { display: none !important; }
          #body-root { background-image: none !important; }
        ` : ""}
        ${(selectedLayout === "layout-a4print" || 
          selectedLayout === "layout-a5print" || 
          selectedLayout === "layout-a6print") ? `
          html { filter: grayscale(1) !important; }
          div.mobile-menu { display: none; }
        ` : ""}
        ${(selectedLayout === "layout-pdf") ? `          
          div.mobile-menu { display: none; }
        ` : ""}
      `}</style>      
    </>
  );
}

export default Widgets;
